import { useCallback, useMemo, useState } from 'react'
import { ssoStorage } from '../ssoStorage'
import { SSO_CLIENT, OPAU_CLIENT_GROUP_NAME } from '../types'
import type { ClientSSOContext } from '../types'

const MANUAL_INTEGRATION_CLIENTS: SSO_CLIENT[] = [
  SSO_CLIENT.HDA,
  SSO_CLIENT.TELECARE,
  SSO_CLIENT.TELADOC_SOLO,
]

export function useSSOContext() {
  const [context, setContext] = useState<ClientSSOContext | null>(() => ssoStorage.getContext())

  const isManualIntegrationClient = !!(
    context?.clientName &&
    (MANUAL_INTEGRATION_CLIENTS.includes(context.clientName) ||
      context.clientName.startsWith(OPAU_CLIENT_GROUP_NAME))
  )

  const clearExternalPatientData = useCallback(() => {
    ssoStorage.clearExternalPatient()
    setContext(ssoStorage.getContext())
  }, [])

  return useMemo(
    () => ({
      context,
      clientName: context?.clientName,
      providerId: context?.providerId,
      providerPlatform: context?.providerPlatform,
      providerType: context?.providerType,
      externalPatientFetchId: context?.externalPatientFetchId,
      referralId: context?.referralId,
      metadata: context?.metadata,
      isManualIntegrationClient,
      isSSOUser: !!context?.clientName,
      clearExternalPatientData,
    }),
    [context, isManualIntegrationClient, clearExternalPatientData]
  )
}
